/**
 * Hero section
 */
(function($, window) {
	$(document).ready(function() {
		if ($('body').hasClass('not-logged-in')) {
			/** -- Background images -- **/
			$('.sectionHero .bg-image').each(function(i, elm) { 
				var imageSrc = $(elm).find('img').attr('src');
				console.log('imageSrc', imageSrc);
				
				if(imageSrc !== undefined || imageSrc !== "undefined") {
					$(elm).parents('.sectionHero').css("background-image", "url(" + imageSrc + ")");
					$(elm).parents('.sectionHero').addClass('cover-bg');
					
					$(elm).remove(); 
				}
			});
			/** -- background images end -- **/
		}
		
	});
	
})(jQuery, window);